function UserNotActivated() {
  return (
    <section className="section-border border-primary">
      <div className="container d-flex flex-column">
        <div className="row align-items-center justify-content-center gx-0 min-vh-100">
          <div className="col-12 col-md-5 col-lg-4 py-8 py-md-11">
            <h1 className="display-3 fw-bold text-center">Uh Oh.</h1>

            <p className="mb-5 text-center text-muted">
              Sorry this account has not yet been activated. Please contact
              Kegow support for more info.
            </p>

            <div className="text-center">
              <a href="/" className="btn btn-primary">
                Back to safety
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UserNotActivated;
